// Number formatting shared by the analytics screens (Polish locale conventions).

export const fmtNum = (v: number | null | undefined, digits = 0): string =>
  v === null || v === undefined ? '—' : v.toLocaleString('pl-PL', { minimumFractionDigits: digits, maximumFractionDigits: digits });

export const fmtPct = (v: number | null | undefined, digits = 1): string =>
  v === null || v === undefined ? '—' : `${(v * 100).toLocaleString('pl-PL', { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`;

/** Minutes -> "12h 34min" / "34min" / "0min". */
export const fmtMin = (min: number | null | undefined): string => {
  if (min === null || min === undefined) return '—';
  const total = Math.round(min);
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m}min`;
  return `${h}h ${String(m).padStart(2, '0')}min`;
};

/** Minutes -> hours with one decimal ("1259,7 h"). */
export const fmtHours = (min: number | null | undefined): string =>
  min === null || min === undefined ? '—' : `${fmtNum(min / 60, 1)} h`;

/** Relative change; null when there is nothing to compare against. */
export const deltaPct = (current: number | null | undefined, previous: number | null | undefined): number | null => {
  if (current === null || current === undefined || previous === null || previous === undefined || previous === 0) return null;
  return (current - previous) / Math.abs(previous);
};

export const fmtDate = (iso: string): string => {
  const [, m, d] = iso.split('-');
  return `${d}.${m}`;
};
